<template>
  <div class="page flex-col">
    <div class="mod4 flex-col">
      <div class="flex-row" style="padding:10px 0px 10px 0px;">
        <div class="flex-col"
          style="flex: 0.8;font-size: 16px;padding:0px 20px 20px 20px;margin-right: 20px;background-color: #FFFFFF;position: relative;min-height: 600px;justify-content: space-between;">
          <div>
            <div class="flex-col align-center" style="margin-top: 30px;">
              <el-image style="width: 60px;height: 60px;border-radius: 50%;" :src="userInfo.avatar"></el-image>
              <span style="margin-top: 5px;font-size: 20px;">{{userInfo.nickName}}</span>
              <span style="margin-top: 5px;color: #999999;font-size: 15px;">{{userInfo.organization}}1221</span>
            </div>
            <div class="flex-row align-center" style="margin-top: 20px;">
              <img style="width: 20px;" src="../assets/center/mail@2x.png" />
              <span style="color:#262626 ;font-weight: 600;font-size: 15px;">邮箱</span>
              <span style="color:#999 ;margin-left: 4px;font-size: 15px;">{{userInfo.mail}}</span>
            </div>
            <div class="flex-col">
              <div class="flex-row align-center" style="margin-top: 20px;">
                <img style="width: 20px;" src="../assets/center/card@2x.png" />
                <span style="color:#262626 ;font-weight: 600;font-size: 15px;">自我介绍</span>
              </div>
              <span style="color:#999 ;margin-left: 4px;">{{userInfo.introduction}}</span>
            </div>
            <div class="flex-row align-center" style="margin-top: 20px;">
              <img style="width: 20px;" src="../assets/center/bz.png" />
              <span style="color:#262626 ;font-weight: 600;font-size: 15px;">账户类型</span>
              <span
                style="margin-left: 6px;font-size: 12px;background: linear-gradient(90deg, #F2E1D2 0%, #CDA891 100%);height: 20px;border-radius: 5px;padding-left: 10px;padding-right: 10px;display: flex;align-items: center;color: #533317;">{{userInfo.rankId?'会员':'用户'}}</span>
            </div>
            <div v-if="userInfo.rankId" class="flex-row align-center" style="margin-top: 20px;">
              <img style="width: 23px;margin-left: -2px;" src="../assets/center/calendar@2x.png" />
              <span style="color:#262626 ;font-weight: 600;font-size: 15px;">账户到期日期</span>
              <span style="color:#999 ;margin-left: 4px;font-size: 15px;">{{userInfo.vipValidityDate}}</span>
            </div>
            <div v-if="userInfo.rankId" class="flex-row justify-center" style="margin-top: 40px;">
              <div class="btnxf">帐户升级及续费</div>
            </div>
          </div>

          <!-- <div style="display: flex;justify-content: center;">
            <div class="left_bottom">
              <div style="flex: 1;display: flex;justify-content: center;cursor: pointer;">我的书架</div>
              <div style="width: 1px;background-color: #EBEBEB;height: 30px;"></div>
              <div style="flex: 1;display: flex;justify-content: center;cursor: pointer;">我的笔记</div>
            </div>
          </div> -->
        </div>
        <div style="flex: 3;background-color: #FFFFFF;">
          <el-tabs v-model="activeName">
            <el-tab-pane label="我的收藏" name="0">
              <mysc></mysc>
            </el-tab-pane>
            <el-tab-pane label="我的阅读" name="1">
             <myyd></myyd>
            </el-tab-pane>
          </el-tabs>


        </div>
      </div>
    </div>

    <img data-v-12eea960="" referrerpolicy="no-referrer"
      src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngad5f0d35d719a5e8e532d9026a1423ccdd763d660c0787a153fa85932c23e026"
      class="img1" style="margin-top: 12.427rem;">
  </div>
</template>
<script>
  import ElImageViewer from '@/components/image-viewer.vue'
  import merge from 'webpack-merge'
  import {
    read,
    bookInfo,
    bookPage,
    essearch,
    booksTree,
    feedbackAdd,
    getInfo
  } from '@/api/api'

  import $ from 'jquery'
  import imagePage from './com/imagePage.vue'
  import noData from './com/noData.vue'
  import mysc from './com/mysc/index.vue'
  import myyd from './com/myyd/index.vue'
  export default {
    components: {
      ElImageViewer,
      mysc,
      myyd,
      noData
    },
    data() {
      return {
        scParam: {
          pageNum: 1,
          pageSize: 20,
        },
        scToTal: 0,
        activeName: '0',
        list: [],
        userInfo: {},
      };
    },
    created: function() {
      getInfo().then((res) => {
        console.log(res)
        this.userInfo = res.user
      })
    },
    methods: {
      queryReadList(){
        readList(this.ydParam).then((res) => {
          console.log(res)
          this.list = res.rows
          this.scToTal = res.total
        })
      },

    },
  };
</script>
<style scoped>
  .ftitle {
    margin-left: 10px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #454545;
  }

  .fcontent {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #454545;
  }

  .name {
    font-size: 15px;
    color: #6E6D6D;
  }

  .value {
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #454545;
  }

  .menubg {
    height: 50px;
    padding-left: 10px;
    margin-top: 10px;
    background: url('../assets/detail/xy.png') 0rem 0rem no-repeat;
    background-size: 100% 100%;
  }

  .menu_item {
    cursor: pointer;
    margin-right: 30px;
  }

  .menu_item span {
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin-left: 5px;
    color: #262626;
  }

  .page_left {
    width: 1.2rem;
    height: 1.2rem;
    background: url('../assets/img/icon_left.png') -0.027rem 0rem no-repeat;
    background-size: 1.227rem 1.2rem;
    margin-top: 5.4rem;
  }

  .page_left:hover {
    opacity: 0.79;
  }

  .page_right {
    width: 1.2rem;
    height: 1.2rem;
    background: url('../assets/img/icon_right.png') -0.027rem 0rem no-repeat;
    background-size: 1.227rem 1.2rem;
    margin: 5.4rem 0 0 1.174rem;
  }

  .page_right:hover {
    opacity: 0.79;
  }

  .page {
    position: relative;
    height: 24.5rem;
    background-color: rgba(245, 245, 245, 1);
    overflow: hidden;
  }

  .mod4 {
    overflow: hidden;
    z-index: 32;
    width: 32rem !important;
    height: 22.5rem;
    width: 12rem;
    position: absolute;
    left: 3.2rem;
    top: 1.014rem;
  }

  .outer1 {
    width: 100% !important;
    height: 10.854rem !important;
  }

  .outer3 {
    z-index: 126;
    border-radius: 9px;
    background-color: #F3F3F3;
    width: 100%;
    height: 100%;
    position: relative;
  }

  .layer6 {
    width: 100%;
  }

  .mod6 {
    position: relative;
  }


  .btnxf {
    width: 128px;
    height: 28px;
    background: linear-gradient(180deg, #D83147 0%, #AF1622 100%);
    box-shadow: 0px 2px 4px 0px rgba(170, 29, 31, 0.33);
    border-radius: 14px;
    color: white;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .left_bottom {
    align-items: center;
    display: flex;
    width: 198px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: -1px 0px 7px 0px rgba(0, 0, 0, 0.12);
  }

  /deep/ .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 25px 15px;
  }
   /deep/ .el-tabs__item.is-active {
      color: #AA1D1F;
      font-weight: bold;
  }
  /deep/ .el-tabs__active-bar{
    background-color: #AA1D1F;
  }
</style>



// WEBPACK FOOTER //
// src/pages/center.vue